import { render, staticRenderFns } from "./PageActivateUser.vue?vue&type=template&id=286b4dfb&scoped=true&"
import script from "./PageActivateUser.vue?vue&type=script&lang=js&"
export * from "./PageActivateUser.vue?vue&type=script&lang=js&"
import style0 from "./PageActivateUser.vue?vue&type=style&index=0&id=286b4dfb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b4dfb",
  null
  
)

export default component.exports